module.exports = __webpack_public_path__ + "img/vape-shop-custom-website-img-5.2485ec12.webp";